document.addEventListener('DOMContentLoaded', function () {
  var carousels = document.querySelectorAll('.video-product-carousel');

  carousels.forEach(function (carousel, index) {
    var slides = carousel.querySelectorAll('.swiper-slide');
    var swiper = new Swiper(carousel, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 5,
      loop: true,
      loopedSlides: slides.length,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,
      multiObserver: true,
      updateOnWindowResize: true,

      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: carousel.querySelector('.video-button-next'),
        prevEl: carousel.querySelector('.video-button-prev'),
      },
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 'auto',
        },
        1024: {
          slidesPerView: 'auto',
        }
      },
      on: {
        init: function () {
          const swiperInstance = this;
          requestAnimationFrame(() => {
            setTimeout(() => {
              swiperInstance.loopDestroy();
              swiperInstance.loopCreate();
              swiperInstance.update();
              playActiveVideo(swiperInstance);
            }, 300);
          });
        },
        slideChange: function () {
          playActiveVideo(this);
        }
      }
    });

    function playActiveVideo(swiper) {
      var slides = swiper.slides;
      slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });

      var activeSlide = slides[swiper.activeIndex];
      var activeVideo = activeSlide?.querySelector('video');
      if (activeVideo) {
        activeVideo.play();
        activeVideo.onended = function () {
          swiper.slideNext();
        };
      }
    }

    // Modal logic
    var modal = document.querySelector('.video-product-carousel-modal');
    var modalVideo = modal?.querySelector('video');
    var modalClose = modal?.querySelector('.video-product-carousel-modal__close');
    var modalProduct = modal?.querySelector('.video-product-carousel-modal__product');
    var modalToggleProduct = modal?.querySelector('.video-product-carousel-modal__toggle-product-btn');

    function isMobile() {
      return window.innerWidth < 768;
    }

    carousel.querySelectorAll('.video-product-carousel__video').forEach(function (videoEl) {
      videoEl.addEventListener('click', function (e) {
        if (!isMobile()) return;

        e.preventDefault();
        var slide = videoEl.closest('.swiper-slide');
        var videoSrc = videoEl.getAttribute('src');
        var poster = videoEl.getAttribute('poster');
        var productInfo = slide.querySelector('.video-product-carousel__product-info')?.innerHTML;

        var allSlides = Array.from(carousel.querySelectorAll('.swiper-slide'));
        modal._allSlides = allSlides;
        modal._currentIndex = allSlides.indexOf(slide);

        if (modal && modalVideo && modalProduct) {
          modalVideo.src = videoSrc;
          modalVideo.poster = poster;
          modalProduct.innerHTML = productInfo;
          modal.classList.add('active');
          document.body.classList.add('modal-open');
          modalVideo.currentTime = 0;
          modalVideo.muted = false;
          modalVideo.play();

          const muteToggle = modalVideo.closest('.video-product-carousel-modal__video-wrapper')?.querySelector('.mute-toggle');
          if (muteToggle) {
            muteToggle.querySelector('.icon-muted').style.display = 'none';
            muteToggle.querySelector('.icon-unmuted').style.display = 'inline-flex';
          }

          var cartToast = document.getElementById('cart-toast');
          if (cartToast && cartToast.parentNode !== document.body) {
            cartToast._originalParent = cartToast.parentNode;
            document.body.appendChild(cartToast);
          }

          var viewCartButton = cartToast?.querySelector('#view-cart-button');
          if (viewCartButton) {
            viewCartButton.addEventListener('click', function (e) {
              e.preventDefault();
              closeModal();
              const miniCart = document.querySelector('mini-cart');
              if (miniCart?.open) miniCart.open();
            });
          }

          carousel.querySelectorAll('.video-product-carousel__video').forEach(function (video) {
            video.muted = true;
            const muteToggle = video.closest('.video-product-carousel__video-wrapper')?.querySelector('.mute-toggle');
            if (muteToggle) {
              muteToggle.querySelector('.icon-muted').style.display = 'inline-flex';
              muteToggle.querySelector('.icon-unmuted').style.display = 'none';
            }
          });
        }
      });
    });

    if (modal) {
      let touchStartY = null;
      let touchEndY = null;
      const SWIPE_THRESHOLD = 50;

      modal.addEventListener('touchstart', function (e) {
        if (!isMobile() || !modal.classList.contains('active')) return;
        touchStartY = e.touches[0].clientY;
      });

      modal.addEventListener('touchmove', function (e) {
        if (!isMobile() || !modal.classList.contains('active')) return;
        touchEndY = e.touches[0].clientY;
      });

      modal.addEventListener('touchend', function () {
        if (!isMobile() || !modal.classList.contains('active')) return;
        if (touchStartY === null || touchEndY === null) return;
        const deltaY = touchStartY - touchEndY;
        if (Math.abs(deltaY) > SWIPE_THRESHOLD) {
          showModalVideoByIndex(modal._currentIndex + (deltaY > 0 ? 1 : -1));
        }
        touchStartY = null;
        touchEndY = null;
      });

      function showModalVideoByIndex(idx) {
        const slides = modal._allSlides || [];
        if (!slides.length || idx < 0 || idx >= slides.length) return;

        const slide = slides[idx];
        const videoEl = slide.querySelector('video');
        const productInfo = slide.querySelector('.video-product-carousel__product-info')?.innerHTML;

        if (videoEl && modalVideo && modalProduct) {
          const poster = videoEl.getAttribute('poster');
          modalVideo.pause();
          modalVideo.src = videoEl.getAttribute('src');
          modalVideo.poster = poster;
          modalProduct.innerHTML = productInfo;
          modal._currentIndex = idx;

          modalVideo.style.backgroundImage = `url('${poster}')`;
          modalVideo.style.backgroundSize = 'cover';
          modalVideo.style.backgroundColor = 'black';

          modalVideo.load();
          modalVideo.onloadeddata = function () {
            modalVideo.currentTime = 0;
            modalVideo.play().catch((e) => console.warn("🎥 Modal video play error:", e));
          };
        }
      }

      modal._showModalVideoByIndex = showModalVideoByIndex;
    }

    if (modal && modalClose) {
      modalClose.addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }

    function closeModal() {
      if (modal && modalVideo) {
        modal.classList.remove('active');
        document.body.classList.remove('modal-open');
        modalVideo.pause();
        modalVideo.currentTime = 0;
        modalVideo.src = '';

        var cartToast = document.getElementById('cart-toast');
        if (cartToast && cartToast._originalParent) {
          cartToast._originalParent.appendChild(cartToast);
          cartToast._originalParent = null;
        }
      }
    }

    if (modalToggleProduct && modalProduct) {
      modalToggleProduct.addEventListener('click', function () {
        modalProduct.classList.toggle('hidden');
        modalToggleProduct.classList.toggle('rotated');
        const isHidden = modalProduct.classList.contains('hidden');
        modalToggleProduct.setAttribute('aria-label', isHidden ? 'Show Product Details' : 'Hide Product Details');
      });
    }
  });

  document.querySelectorAll('.mute-toggle').forEach(button => {
    const video = button.closest('.video-product-mute')?.querySelector('video');
    const mutedIcon = button.querySelector('.icon-muted');
    const unmutedIcon = button.querySelector('.icon-unmuted');

    button.addEventListener('click', () => {
      if (!video) return;
      video.muted = !video.muted;
      mutedIcon.style.display = video.muted ? 'inline-flex' : 'none';
      unmutedIcon.style.display = video.muted ? 'none' : 'inline-flex';
    });
  });
});
